type EmbedOptions = {
  autoPlay: boolean;
  enabledCaptions: boolean;
};

const EMBED_URL = 'https://www.facebook.com/plugins/video.php';

export const toEmbedUrl = (
  url: string,
  { autoPlay, enabledCaptions }: EmbedOptions,
) => {
  const embedUrl = new URL(EMBED_URL);
  embedUrl.searchParams.set('href', url);
  embedUrl.searchParams.set('autoplay', autoPlay.toString());
  embedUrl.searchParams.set('show_captions', enabledCaptions.toString());
  return embedUrl.toString();
};
